import {
    LOAD_TIPOS_SEGURO_OBSERVACION_SUCCESS,
    TipoSeguroObservacionActionTypes
} from "../types/tipoSeguroObservacionActionTypes";
import {ICatalogo} from "../../entities/catalogos/ICatalogo";


export default function tipoSeguroObservacionReducer(state = [], action: TipoSeguroObservacionActionTypes): ICatalogo[] {
    switch (action.type) {
        case LOAD_TIPOS_SEGURO_OBSERVACION_SUCCESS:
            return action.tiposSeguroObservacion;
        default:
            return state;
    }
}

